import {API_URL, apiPost} from '../api'

interface IRetractPoint {
    tx_id: number
    reason: string
}

export const editUserPointRetract = async (edit_data: IRetractPoint) => {
    return await apiPost(API_URL, 'admin/point/revert', edit_data)
}
